/**
 * BatteryDot — 10 px coloured circle indicating EV battery health.
 * Colours map to the shared status palette (ok / warn / danger) so the dot
 * tracks the theme (incl. dark mode) instead of fixed hexes. The dot is
 * decorative fill, so it uses the solid tokens.
 * Source: .agents/design/project/artboard-radical-vozidla.jsx:163-171
 */

export type BatteryLevel = 'high' | 'medium' | 'low' | 'unknown';

const LEVEL_LABEL: Record<BatteryLevel, string> = {
  high: 'Plná baterie',
  medium: 'Střední baterie',
  low: 'Nízká baterie',
  unknown: 'Neznámý stav baterie',
};

const LEVEL_CLASS: Record<BatteryLevel, string> = {
  high: 'bg-ok border border-ok',
  medium: 'bg-warn border border-warn',
  low: 'bg-red border border-red-text',
  unknown: 'border border-dashed border-line-2',
};

interface BatteryDotProps {
  level: BatteryLevel;
  /** Override the default Czech label. Pass empty string to mark decorative. */
  label?: string;
  className?: string;
}

export function BatteryDot({ level, label, className = '' }: BatteryDotProps) {
  const ariaLabel = label ?? LEVEL_LABEL[level];
  const a11y = ariaLabel
    ? { role: 'img' as const, 'aria-label': ariaLabel }
    : { 'aria-hidden': true };
  return (
    <span
      {...a11y}
      className={`inline-block size-2.5 rounded-full ${LEVEL_CLASS[level]} ${className}`}
    />
  );
}
